import React from "react";

import cn from "classnames";

import { boxForwardRef } from "../../../../../helpers/common/Box/Box";
import { Text } from "../../../../Text";

import type { BoxComponentWithDefault } from "../../../../../helpers/common/Box/Box";
import type { OmitOfUnion } from "../../../../../types/react";
import type { TextProps } from "../../../../Text";

import classes from "./TabLabel.styl";

export type TabLabelProps = OmitOfUnion<
    TextProps,
    | "maxLines"
    | "textCase"
    | "underline"
    | "strikethrough"
    | "truncateStyle"
    | "typographyStyle"
    | "lineHeight"
    | "asList"
    | "quote"
    | "italic"
>;

const TAB_LABEL_TEST_ID = "tab-label-test-id";

export const TabLabel = boxForwardRef<
    BoxComponentWithDefault<"span", TabLabelProps, "className">
>(({ customVarsStyles, children, ...props }, ref) => {
    return (
        <Text
            data-tsid={TAB_LABEL_TEST_ID}
            {...props}
            typographyStyle="body-m"
            maxLines={1}
            customVarsStyles={cn(
                classes["custom-colors-styles"],
                customVarsStyles,
            )}
            ref={ref}
        >
            {children}
        </Text>
    );
});

TabLabel.displayName = "Tab.Label";

export default TabLabel;
